import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TaskSaveService } from '../../services/task-save.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { TaskManagementService } from '../../services/task-management.service';
import { TaskCreationOperation } from 'app/modules/common/enums/task-create-operation-enum';

@Component({
    selector: 'app-add-task',
    templateUrl: './add-task.component.html',
    styleUrls: ['./add-task.component.scss'],
    standalone: false
})
export class AddTaskComponent implements OnInit {
    public isSaving: boolean;
    public snackBarRef;
    public todayDate: any;
    public leaveId: any;
    public employeeId: any;
    public taskCreationOperation = TaskCreationOperation.FromMainPopup;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public taskService: TaskSaveService,
        public dialogRef: MatDialogRef<AddTaskComponent>,
        private sharedService: SharedService,
        public taskManagementService: TaskManagementService
    ) {
        this.todayDate = new Date();
        this.leaveId = data;
    }

    ngOnInit(): void {
        this.employeeId = localStorage.getItem('EmplooyeeID');
    }

    saveTask(): void {
        this.taskManagementService.markFormGroupTouched(
            this.taskManagementService.TaskManagementForm
        );
        this.taskManagementService.TaskManagementForm.updateValueAndValidity();

        if (this.taskManagementService.TaskManagementForm.valid) {
            this.isSaving = true;
           const tarea= this.taskManagementService.TaskManagementForm.get('Tarea').value;
            if(tarea==31201)
            {
                this.taskManagementService.setSelectedTask({
                    id:tarea,
                    espanyol:'REALIZAR CONTACTO TELEFONICO POR INDISPOSICION',
                    nombre:'IndisposicionContacto',
                    texto:'Realizar contacto telefónico por indisposición',
                    tipoAutor:'MC'
                })
            }
            const saveModel = this.taskManagementService.getTaskSaveModel();
            this.taskService.SaveTask(saveModel).subscribe(
                (res) => {
                    if (res.code === 0) {
                        this.taskService.saved.emit();
                        this.sharedService.ShowSnackBar('Guardado con éxito');
                        this.cancel(true);
                    } else {
                        this.sharedService.ShowSnackBar('Se produjo un error, por favor revise si hay algún campo vacío');
                    }
                },
                (err) => {
                    console.error(err);
                    this.sharedService.ShowSnackBar('Se produjo un error');
                },
                () => {
                    this.isSaving = false;
                }
            );
        }
    }

    public cancel(taskCreated = false): void {
        this.taskManagementService.TaskManagementForm.reset();
        this.dialogRef.close(taskCreated);
    }
}
